import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import { addMinRule, addRequiredRule } from '~/helpers/validators/rules';
import { extend } from 'vee-validate';
import { useUser } from '~/composables/_next/useUser';
import AzInput from '~/components/_next/atoms/AzInput.vue';
import AzModal from '~/components/_next/molecules/AzModal.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzForm from '~/components/_next/atoms/AzForm.vue';
import AzFormField from '~/components/_next/atoms/AzFormField.vue';
import { useTrpc } from '~/composables/_next/useTrpc';
export default /*#__PURE__*/_defineComponent({
  __name: 'ModalNewPasswordOrganism',
  props: {
    token: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var route = useRoute();
    var _useUiState = useUiState(),
      togglePasswordModal = _useUiState.togglePasswordModal,
      handleLoginNavigation = _useUiState.handleLoginNavigation;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      i18n = _useNuxt2App.i18n;
    var _useTrpc = useTrpc(),
      client = _useTrpc.client;
    var router = useRouter();
    var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated;
    var modalRef = ref(null);
    var newPasswordForm = ref(null);
    var loading = ref(false);
    var form = ref({});
    addMinRule();
    addRequiredRule();
    extend('password', {
      params: ['target'],
      validate: function validate(value, _ref) {
        var target = _ref.target;
        return value === target;
      },
      message: i18n.t('validator.confirmed')
    });
    onMounted(function () {
      if (props.token && !isAuthenticated.value) {
        modalRef.value.modal.showModal();
      }
    });
    var closeModal = function closeModal() {
      router.push(app.localePath({
        name: 'index'
      }));
      togglePasswordModal();
    };

    /**
     * Confirms the new password
     * Closes the modal afterward
     */
    function confirmNewPassword() {
      return _confirmNewPassword.apply(this, arguments);
    }
    function _confirmNewPassword() {
      _confirmNewPassword = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _form$value, observerValidity, _err$data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              _context.next = 4;
              return newPasswordForm.value.validate();
            case 4:
              observerValidity = _context.sent;
              if (observerValidity) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return");
            case 7:
              _context.next = 9;
              return client.customer.updatePassword.mutate({
                newPassword: (_form$value = form.value) === null || _form$value === void 0 ? void 0 : _form$value.password,
                token: props.token
              });
            case 9:
              modalRef.value.modal.close();
              setTimeout(function () {
                handleLoginNavigation({
                  previousRoutePath: route.path,
                  nextRoutePath: route.path
                });
              }, 100);
              _context.next = 16;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](1);
              if ((_context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$data = _context.t0.data) === null || _err$data === void 0 ? void 0 : _err$data.code) === 'UNAUTHORIZED') {
                newPasswordForm.value.setErrors({
                  repeatPassword: [i18n.t('modals.new-password.error.invalid-url')]
                });
              }
            case 16:
              _context.prev = 16;
              loading.value = false;
              return _context.finish(16);
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 13, 16, 19]]);
      }));
      return _confirmNewPassword.apply(this, arguments);
    }
    return {
      __sfc: true,
      props: props,
      route: route,
      togglePasswordModal: togglePasswordModal,
      handleLoginNavigation: handleLoginNavigation,
      app: app,
      i18n: i18n,
      client: client,
      router: router,
      isAuthenticated: isAuthenticated,
      modalRef: modalRef,
      newPasswordForm: newPasswordForm,
      loading: loading,
      form: form,
      closeModal: closeModal,
      confirmNewPassword: confirmNewPassword,
      AzInput: AzInput,
      AzModal: AzModal,
      AzButton: AzButton,
      AzForm: AzForm,
      AzFormField: AzFormField
    };
  }
});